const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  CREATE_ONE_CLICK_CQ_BEGIN: "CREATE_ONE_CLICK_CQ_BEGIN",
  CREATE_ONE_CLICK_CQ_SUCCESS: "CREATE_ONE_CLICK_CQ_SUCCESS",
  CREATE_ONE_CLICK_CQ_FAILURE: "CREATE_ONE_CLICK_CQ_FAILURE",

  DELETE_SERVICE_BY_EXPRESS_ORDER_BEGIN:
    "DELETE_SERVICE_BY_EXPRESS_ORDER_BEGIN",
  DELETE_SERVICE_BY_EXPRESS_ORDER_SUCCESS:
    "DELETE_SERVICE_BY_EXPRESS_ORDER_SUCCESS",
  DELETE_SERVICE_BY_EXPRESS_ORDER_FAILURE:
    "DELETE_SERVICE_BY_EXPRESS_ORDER_FAILURE",

  CONFIRM_ONE_CLICK_CQ_BEGIN: "CONFIRM_ONE_CLICK_CQ_BEGIN",
  CONFIRM_ONE_CLICK_CQ_SUCCESS: "CONFIRM_ONE_CLICK_CQ_SUCCESS",
  CONFIRM_ONE_CLICK_CQ_FAILURE: "CONFIRM_ONE_CLICK_CQ_FAILURE",

  RESET_ONE_CLICK: "RESET_ONE_CLICK",
};

export const actions = {
  createOneClickCq: (data) => ({
    type: types.CREATE_ONE_CLICK_CQ_BEGIN,
    data,
  }),
  successCreateOneClickCq: (data) => ({
    type: types.CREATE_ONE_CLICK_CQ_SUCCESS,
    payload: data,
  }),
  failureCreateOneClickCq: (error) => ({
    type: types.CREATE_ONE_CLICK_CQ_FAILURE,
    payload: error,
  }),
  deleteServiceByExpressOrder: (data) => ({
    type: types.DELETE_SERVICE_BY_EXPRESS_ORDER_BEGIN,
    data,
  }),
  successDeleteServiceByExpressOrder: (data) => ({
    type: types.DELETE_SERVICE_BY_EXPRESS_ORDER_SUCCESS,
    payload: data,
  }),
  failureDeleteServiceByExpressOrder: (error) => ({
    type: types.DELETE_SERVICE_BY_EXPRESS_ORDER_FAILURE,
    payload: error,
  }),
  confirmOneClickCq: (data) => ({
    type: types.CONFIRM_ONE_CLICK_CQ_BEGIN,
    data,
  }),
  successConfirmOneClickCq: (data) => ({
    type: types.CONFIRM_ONE_CLICK_CQ_SUCCESS,
    payload: data,
  }),
  failureConfirmOneClickCq: (error) => ({
    type: types.CONFIRM_ONE_CLICK_CQ_FAILURE,
    payload: error,
  }),
  resetOneClick: () => ({ type: types.RESET_ONE_CLICK }),
};

export const initialState = {
  createOneClickCq: null,
  createOneClickCqFetching: false,
  createOneClickCqError: false,

  deleteServiceByExpressOrder: null,
  deleteServiceByExpressOrderFetching: false,
  deleteServiceByExpressOrderError: false,

  confirmOneClickCq: null,
  confirmOneClickCqFetching: false,
  confirmOneClickCqError: false,
};

function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { oneClick } = payload;
      return {
        ...state,
        ...oneClick,
      };
    }
    case types.CREATE_ONE_CLICK_CQ_BEGIN: {
      return {
        ...state,
        createOneClickCq: null,
        createOneClickCqFetching: true,
        createOneClickCqError: false,

        confirmOneClickCq: null,
        confirmOneClickCqFetching: false,
        confirmOneClickCqError: false,
      };
    }
    case types.CREATE_ONE_CLICK_CQ_SUCCESS: {
      return {
        ...state,
        createOneClickCq: payload,
        createOneClickCqFetching: false,
        createOneClickCqError: false,
      };
    }
    case types.CREATE_ONE_CLICK_CQ_FAILURE: {
      return {
        ...state,
        createOneClickCq: null,
        createOneClickCqFetching: false,
        createOneClickCqError: true,
      };
    }
    case types.DELETE_SERVICE_BY_EXPRESS_ORDER_BEGIN: {
      return {
        ...state,
        deleteServiceByExpressOrder: null,
        deleteServiceByExpressOrderFetching: true,
        deleteServiceByExpressOrderError: false,
      };
    }
    case types.DELETE_SERVICE_BY_EXPRESS_ORDER_SUCCESS: {
      return {
        ...state,
        deleteServiceByExpressOrder: payload,
        deleteServiceByExpressOrderFetching: false,
        deleteServiceByExpressOrderError: false,
      };
    }
    case types.DELETE_SERVICE_BY_EXPRESS_ORDER_FAILURE: {
      return {
        ...state,
        deleteServiceByExpressOrder: null,
        deleteServiceByExpressOrderFetching: false,
        deleteServiceByExpressOrderError: true,
      };
    }

    case types.CONFIRM_ONE_CLICK_CQ_BEGIN: {
      return {
        ...state,
        confirmOneClickCq: null,
        confirmOneClickCqFetching: true,
        confirmOneClickCqError: false,
      };
    }
    case types.CONFIRM_ONE_CLICK_CQ_SUCCESS: {
      return {
        ...state,
        confirmOneClickCq: payload,
        confirmOneClickCqFetching: false,
        confirmOneClickCqError: false,
      };
    }
    case types.CONFIRM_ONE_CLICK_CQ_FAILURE: {
      return {
        ...state,
        confirmOneClickCq: null,
        confirmOneClickCqFetching: false,
        confirmOneClickCqError: true,
      };
    }
    case types.RESET_ONE_CLICK: {
      return {
        ...state,
        createOneClickCq: null,
        createOneClickCqFetching: false,
        createOneClickCqError: false,
        confirmOneClickCq: null,
        confirmOneClickCqFetching: false,
        confirmOneClickCqError: false,
      };
    }
    default:
      return state;
  }
}

export default reducer;
